var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7639",
    "data-name": "Group 7639",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318.074,
    height: 351.353,
    viewBox: "0 0 318.074 351.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6212",
    "data-name": "Rectangle 6212",
    width: 318.074,
    height: 351.353,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23969",
    "data-name": "Path 23969",
    d: "M76.578,2221.823c-23.818,10.336-13.753,35.269-51.312,51.569,20.2-8.768,33.023-5.3,44.263-1.826,9.656,2.982,18.147,5.964,29.152,1.188,23.818-10.337,17.7-37.942,17.7-37.942s-10.711-15.631-27.661-15.632a30.261,30.261,0,0,0-12.138,2.642",
    transform: "translate(-25.266 -2219.181)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6211",
    "data-name": "Rectangle 6211",
    width: 318.074,
    height: 351.353,
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6178",
    "data-name": "Rectangle 6178",
    width: 91.816,
    height: 54.212,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6179",
    "data-name": "Rectangle 6179",
    width: 90.67,
    height: 22.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6180",
    "data-name": "Rectangle 6180",
    width: 15.599,
    height: 28.774,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6181",
    "data-name": "Rectangle 6181",
    width: 28.411,
    height: 54.684,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6182",
    "data-name": "Rectangle 6182",
    width: 58.4,
    height: 15.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6183",
    "data-name": "Rectangle 6183",
    width: 31.768,
    height: 23.532,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6184",
    "data-name": "Rectangle 6184",
    width: 72.411,
    height: 24.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6185",
    "data-name": "Rectangle 6185",
    width: 64.321,
    height: 64.32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6186",
    "data-name": "Rectangle 6186",
    width: 57.356,
    height: 37.71,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6187",
    "data-name": "Rectangle 6187",
    width: 57.835,
    height: 33.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6188",
    "data-name": "Rectangle 6188",
    width: 36.785,
    height: 24.577,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6189",
    "data-name": "Rectangle 6189",
    width: 36.794,
    height: 24.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6190",
    "data-name": "Rectangle 6190",
    width: 23.012,
    height: 10.473,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6191",
    "data-name": "Rectangle 6191",
    width: 11.408,
    height: 9.834,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6192",
    "data-name": "Rectangle 6192",
    width: 215.481,
    height: 113.131,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6193",
    "data-name": "Rectangle 6193",
    width: 49.792,
    height: 23.564,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6194",
    "data-name": "Rectangle 6194",
    width: 49.787,
    height: 22.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6195",
    "data-name": "Rectangle 6195",
    width: 96.364,
    height: 37.556,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6196",
    "data-name": "Rectangle 6196",
    width: 50.648,
    height: 64.261,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6197",
    "data-name": "Rectangle 6197",
    width: 70.315,
    height: 46.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6198",
    "data-name": "Rectangle 6198",
    width: 109.003,
    height: 133.176,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6199",
    "data-name": "Rectangle 6199",
    width: 28.207,
    height: 24.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6200",
    "data-name": "Rectangle 6200",
    width: 44.41,
    height: 36.374,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6201",
    "data-name": "Rectangle 6201",
    width: 54.304,
    height: 29.86,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6202",
    "data-name": "Rectangle 6202",
    width: 79.117,
    height: 45.787,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6203",
    "data-name": "Rectangle 6203",
    width: 14.616,
    height: 12.337,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6204",
    "data-name": "Rectangle 6204",
    width: 57.614,
    height: 14.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6205",
    "data-name": "Rectangle 6205",
    width: 131.812,
    height: 90.397,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6206",
    "data-name": "Rectangle 6206",
    width: 35.534,
    height: 37.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6207",
    "data-name": "Rectangle 6207",
    width: 16.456,
    height: 17.968,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6208",
    "data-name": "Rectangle 6208",
    width: 6.773,
    height: 7.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6209",
    "data-name": "Rectangle 6209",
    width: 63.132,
    height: 36.935,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6210",
    "data-name": "Rectangle 6210",
    width: 29.067,
    height: 25.358,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7638",
    "data-name": "Group 7638",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7536",
    "data-name": "Group 7536",
    transform: "translate(3.119 273.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7535",
    "data-name": "Group 7535",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23855",
    "data-name": "Path 23855",
    d: "M25.266,2658.322l5.157,9.7H25.266Z",
    transform: "translate(-25.266 -2604.111)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23856",
    "data-name": "Path 23856",
    d: "M25.266,2648.55l5.8,10.905h-.642l-5.157-9.7Z",
    transform: "translate(-25.266 -2595.544)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23857",
    "data-name": "Path 23857",
    d: "M25.266,2638.777l6.44,12.111h-.642l-5.8-10.9Z",
    transform: "translate(-25.266 -2586.978)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23858",
    "data-name": "Path 23858",
    d: "M25.266,2629l7.082,13.318h-.641l-6.44-12.111Z",
    transform: "translate(-25.266 -2578.412)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23859",
    "data-name": "Path 23859",
    d: "M25.266,2619.231l7.723,14.524h-.642l-7.082-13.318Z",
    transform: "translate(-25.266 -2569.846)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23860",
    "data-name": "Path 23860",
    d: "M25.266,2609.458l8.365,15.73h-.642l-7.723-14.524Z",
    transform: "translate(-25.266 -2561.279)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23861",
    "data-name": "Path 23861",
    d: "M25.266,2599.686l9.006,16.937h-.642l-8.365-15.731Z",
    transform: "translate(-25.266 -2552.713)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23862",
    "data-name": "Path 23862",
    d: "M25.266,2589.913l9.648,18.143h-.641l-9.006-16.937Z",
    transform: "translate(-25.266 -2544.146)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23863",
    "data-name": "Path 23863",
    d: "M25.266,2580.14l10.289,19.35h-.642l-9.648-18.143Z",
    transform: "translate(-25.266 -2535.58)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23864",
    "data-name": "Path 23864",
    d: "M25.266,2570.368,36.2,2590.924h-.642l-10.289-19.35Z",
    transform: "translate(-25.266 -2527.014)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23865",
    "data-name": "Path 23865",
    d: "M25.266,2560.595l11.573,21.763H36.2L25.266,2561.8Z",
    transform: "translate(-25.266 -2518.448)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23866",
    "data-name": "Path 23866",
    d: "M25.266,2550.822l12.214,22.969h-.641l-11.573-21.763Z",
    transform: "translate(-25.266 -2509.881)",
    fill: "#ec1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23867",
    "data-name": "Path 23867",
    d: "M25.266,2541.049l12.856,24.176H37.48l-12.214-22.969Z",
    transform: "translate(-25.266 -2501.315)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23868",
    "data-name": "Path 23868",
    d: "M25.266,2531.277l13.5,25.382h-.642l-12.856-24.176Z",
    transform: "translate(-25.266 -2492.749)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23869",
    "data-name": "Path 23869",
    d: "M25.266,2521.5,39.4,2548.093h-.642l-13.5-25.382Z",
    transform: "translate(-25.266 -2484.182)",
    fill: "#ec1e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23870",
    "data-name": "Path 23870",
    d: "M25.266,2511.731l14.78,27.795H39.4l-14.139-26.588Z",
    transform: "translate(-25.266 -2475.616)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23871",
    "data-name": "Path 23871",
    d: "M25.266,2501.958l15.422,29h-.642l-14.78-27.8Z",
    transform: "translate(-25.266 -2467.05)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23872",
    "data-name": "Path 23872",
    d: "M25.266,2492.186l16.063,30.208h-.642l-15.422-29Z",
    transform: "translate(-25.266 -2458.483)",
    fill: "#ec1f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23873",
    "data-name": "Path 23873",
    d: "M25.266,2482.413l16.7,31.414h-.642l-16.063-30.208Z",
    transform: "translate(-25.266 -2449.917)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23874",
    "data-name": "Path 23874",
    d: "M25.266,2472.64l17.346,32.621h-.641l-16.7-31.414Z",
    transform: "translate(-25.266 -2441.351)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23875",
    "data-name": "Path 23875",
    d: "M25.266,2462.867l17.988,33.827h-.642l-17.346-32.621Z",
    transform: "translate(-25.266 -2432.784)",
    fill: "#ec2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23876",
    "data-name": "Path 23876",
    d: "M25.266,2453.095,43.9,2488.128h-.642L25.266,2454.3Z",
    transform: "translate(-25.266 -2424.218)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23877",
    "data-name": "Path 23877",
    d: "M25.266,2443.322l19.271,36.24H43.9l-18.629-35.034Z",
    transform: "translate(-25.266 -2415.652)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23878",
    "data-name": "Path 23878",
    d: "M25.266,2433.549,45.178,2471h-.641l-19.271-36.24Z",
    transform: "translate(-25.266 -2407.086)",
    fill: "#ed2124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23879",
    "data-name": "Path 23879",
    d: "M25.266,2429.945l.391-.208,20.163,37.917h-.642l-19.912-37.447Z",
    transform: "translate(-25.266 -2403.744)",
    fill: "#ed2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23880",
    "data-name": "Path 23880",
    d: "M28.435,2427.849l.5-.266,20.3,38.183H48.6Z",
    transform: "translate(-28.044 -2401.856)",
    fill: "#ed2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23881",
    "data-name": "Path 23881",
    d: "M32.487,2425.695l.5-.266,20.446,38.449h-.642Z",
    transform: "translate(-31.595 -2399.968)",
    fill: "#ed2324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23882",
    "data-name": "Path 23882",
    d: "M36.538,2423.54l.5-.266,20.587,38.715h-.642Z",
    transform: "translate(-35.146 -2398.079)",
    fill: "#ed2324"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23883",
    "data-name": "Path 23883",
    d: "M40.589,2421.386l.5-.266L61.818,2460.1h-.642Z",
    transform: "translate(-38.697 -2396.191)",
    fill: "#ed2424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23884",
    "data-name": "Path 23884",
    d: "M44.64,2419.232l.5-.266,20.87,39.247h-.642Z",
    transform: "translate(-42.249 -2394.302)",
    fill: "#ed2424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23885",
    "data-name": "Path 23885",
    d: "M48.691,2417.078l.5-.266L70.2,2456.324h-.642Z",
    transform: "translate(-45.8 -2392.415)",
    fill: "#ed2524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23886",
    "data-name": "Path 23886",
    d: "M52.743,2414.923l.5-.266L74.4,2454.436h-.641Z",
    transform: "translate(-49.351 -2390.526)",
    fill: "#ed2524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23887",
    "data-name": "Path 23887",
    d: "M56.794,2412.769l.5-.266,21.294,40.045h-.642Z",
    transform: "translate(-52.902 -2388.638)",
    fill: "#ed2624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23888",
    "data-name": "Path 23888",
    d: "M60.845,2410.615l.5-.266,21.435,40.311h-.641Z",
    transform: "translate(-56.453 -2386.75)",
    fill: "#ed2624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23889",
    "data-name": "Path 23889",
    d: "M64.9,2408.461l.5-.266,21.577,40.576h-.642Z",
    transform: "translate(-60.004 -2384.861)",
    fill: "#ed2724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23890",
    "data-name": "Path 23890",
    d: "M68.948,2406.307l.5-.266,21.718,40.843h-.641Z",
    transform: "translate(-63.555 -2382.973)",
    fill: "#ed2724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23891",
    "data-name": "Path 23891",
    d: "M73,2404.152l.5-.266,21.86,41.108h-.642Z",
    transform: "translate(-67.106 -2381.084)",
    fill: "#ed2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23892",
    "data-name": "Path 23892",
    d: "M77.05,2402l.5-.266,22,41.374H98.91Z",
    transform: "translate(-70.657 -2379.196)",
    fill: "#ed2824"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23893",
    "data-name": "Path 23893",
    d: "M81.1,2399.844l.5-.266,22.143,41.64H103.1Z",
    transform: "translate(-74.208 -2377.308)",
    fill: "#ed2924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23894",
    "data-name": "Path 23894",
    d: "M85.152,2397.689l.5-.266,22.284,41.906h-.642Z",
    transform: "translate(-77.759 -2375.419)",
    fill: "#ed2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23895",
    "data-name": "Path 23895",
    d: "M89.2,2395.535l.5-.266,22.425,42.172h-.642Z",
    transform: "translate(-81.31 -2373.531)",
    fill: "#ee2a24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23896",
    "data-name": "Path 23896",
    d: "M93.255,2393.381l.5-.266,22.567,42.438h-.642Z",
    transform: "translate(-84.862 -2371.643)",
    fill: "#ee2b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23897",
    "data-name": "Path 23897",
    d: "M97.306,2391.227l.5-.266,22.708,42.7h-.641Z",
    transform: "translate(-88.413 -2369.755)",
    fill: "#ee2b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23898",
    "data-name": "Path 23898",
    d: "M101.357,2389.072l.5-.266,22.85,42.97h-.642Z",
    transform: "translate(-91.964 -2367.866)",
    fill: "#ee2c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23899",
    "data-name": "Path 23899",
    d: "M105.408,2386.918l.5-.266,22.991,43.236h-.641Z",
    transform: "translate(-95.515 -2365.978)",
    fill: "#ee2d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23900",
    "data-name": "Path 23900",
    d: "M109.46,2384.764l.5-.266,23.133,43.5h-.642Z",
    transform: "translate(-99.066 -2364.09)",
    fill: "#ee2d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23901",
    "data-name": "Path 23901",
    d: "M113.511,2382.609l.5-.266,23.274,43.768h-.641Z",
    transform: "translate(-102.617 -2362.201)",
    fill: "#ee2e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23902",
    "data-name": "Path 23902",
    d: "M117.562,2380.455l.5-.266,23.415,44.034h-.642Z",
    transform: "translate(-106.168 -2360.313)",
    fill: "#ee2f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23903",
    "data-name": "Path 23903",
    d: "M121.613,2378.3l.5-.266,23.557,44.3h-.642Z",
    transform: "translate(-109.719 -2358.425)",
    fill: "#ee2f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23904",
    "data-name": "Path 23904",
    d: "M125.664,2376.147l.5-.266,23.7,44.566h-.642Z",
    transform: "translate(-113.27 -2356.536)",
    fill: "#ee3024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23905",
    "data-name": "Path 23905",
    d: "M129.715,2373.992l.5-.266,23.84,44.832h-.642Z",
    transform: "translate(-116.821 -2354.648)",
    fill: "#ee3124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23906",
    "data-name": "Path 23906",
    d: "M133.767,2371.838l.5-.266,23.981,45.1h-.642Z",
    transform: "translate(-120.372 -2352.76)",
    fill: "#ee3224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23907",
    "data-name": "Path 23907",
    d: "M137.818,2369.684l.5-.266,24.122,45.363H161.8Z",
    transform: "translate(-123.923 -2350.871)",
    fill: "#ee3225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23908",
    "data-name": "Path 23908",
    d: "M141.869,2367.53l.5-.266,24.264,45.629h-.641Z",
    transform: "translate(-127.475 -2348.983)",
    fill: "#ef3325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23909",
    "data-name": "Path 23909",
    d: "M145.92,2365.375l.5-.266,24.405,45.9h-.642Z",
    transform: "translate(-131.026 -2347.095)",
    fill: "#ef3425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23910",
    "data-name": "Path 23910",
    d: "M149.971,2363.221l.5-.266,24.547,46.161h-.641Z",
    transform: "translate(-134.577 -2345.207)",
    fill: "#ef3525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23911",
    "data-name": "Path 23911",
    d: "M154.023,2361.067l.5-.266,24.688,46.427h-.642Z",
    transform: "translate(-138.128 -2343.318)",
    fill: "#ef3525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23912",
    "data-name": "Path 23912",
    d: "M158.074,2358.913l.5-.266,24.83,46.693h-.642Z",
    transform: "translate(-141.679 -2341.43)",
    fill: "#ef3625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23913",
    "data-name": "Path 23913",
    d: "M162.125,2356.758l.5-.266,24.971,46.959h-.642Z",
    transform: "translate(-145.23 -2339.542)",
    fill: "#ef3725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23914",
    "data-name": "Path 23914",
    d: "M166.176,2354.6l.5-.266,25.112,47.225h-.642Z",
    transform: "translate(-148.781 -2337.653)",
    fill: "#ef3825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23915",
    "data-name": "Path 23915",
    d: "M170.227,2352.45l.5-.266,25.254,47.491h-.642Z",
    transform: "translate(-152.332 -2335.765)",
    fill: "#ef3925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23916",
    "data-name": "Path 23916",
    d: "M174.279,2350.3l.5-.266,25.4,47.757h-.642Z",
    transform: "translate(-155.883 -2333.877)",
    fill: "#ef3925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23917",
    "data-name": "Path 23917",
    d: "M178.33,2348.141l.5-.266,25.537,48.023h-.641Z",
    transform: "translate(-159.434 -2331.988)",
    fill: "#ef3a25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23918",
    "data-name": "Path 23918",
    d: "M182.381,2345.987l.5-.266,25.678,48.289h-.642Z",
    transform: "translate(-162.985 -2330.1)",
    fill: "#ef3b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23919",
    "data-name": "Path 23919",
    d: "M186.432,2343.833l.5-.266,25.819,48.555h-.641Z",
    transform: "translate(-166.536 -2328.212)",
    fill: "#ef3c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23920",
    "data-name": "Path 23920",
    d: "M190.484,2341.679l.5-.266,25.961,48.821H216.3Z",
    transform: "translate(-170.088 -2326.323)",
    fill: "#f03d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23921",
    "data-name": "Path 23921",
    d: "M194.535,2339.524l.5-.266,26.1,49.086H220.5Z",
    transform: "translate(-173.639 -2324.435)",
    fill: "#f03e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23922",
    "data-name": "Path 23922",
    d: "M198.586,2337.37l.5-.266,26.244,49.353h-.642Z",
    transform: "translate(-177.19 -2322.547)",
    fill: "#f03e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23923",
    "data-name": "Path 23923",
    d: "M202.637,2335.216l.5-.266,26.385,49.618h-.642Z",
    transform: "translate(-180.741 -2320.658)",
    fill: "#f03f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23924",
    "data-name": "Path 23924",
    d: "M206.688,2333.062l.5-.266,26.526,49.885h-.642Z",
    transform: "translate(-184.292 -2318.77)",
    fill: "#f04025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23925",
    "data-name": "Path 23925",
    d: "M210.74,2330.907l.5-.266,26.668,50.15h-.642Z",
    transform: "translate(-187.843 -2316.882)",
    fill: "#f04125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23926",
    "data-name": "Path 23926",
    d: "M214.791,2328.753l.5-.266L242.1,2378.9h-.642Z",
    transform: "translate(-191.394 -2314.993)",
    fill: "#f04225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23927",
    "data-name": "Path 23927",
    d: "M218.842,2326.6l.5-.266,26.951,50.682h-.642Z",
    transform: "translate(-194.945 -2313.105)",
    fill: "#f04325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23928",
    "data-name": "Path 23928",
    d: "M222.893,2324.445l.5-.266,27.092,50.948h-.642Z",
    transform: "translate(-198.496 -2311.217)",
    fill: "#f04425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23929",
    "data-name": "Path 23929",
    d: "M226.944,2322.29l.5-.266,27.234,51.214h-.642Z",
    transform: "translate(-202.047 -2309.329)",
    fill: "#f04525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23930",
    "data-name": "Path 23930",
    d: "M231,2320.136l.5-.266,27.375,51.48h-.641Z",
    transform: "translate(-205.598 -2307.44)",
    fill: "#f14625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23931",
    "data-name": "Path 23931",
    d: "M235.047,2317.982l.5-.266,27.516,51.746h-.642Z",
    transform: "translate(-209.149 -2305.552)",
    fill: "#f14725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23932",
    "data-name": "Path 23932",
    d: "M239.1,2315.827l.5-.266,27.658,52.012h-.641Z",
    transform: "translate(-212.701 -2303.663)",
    fill: "#f14825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23933",
    "data-name": "Path 23933",
    d: "M243.149,2313.673l.5-.266,27.8,52.278h-.642Z",
    transform: "translate(-216.252 -2301.775)",
    fill: "#f14925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23934",
    "data-name": "Path 23934",
    d: "M247.2,2311.519l.5-.266,27.941,52.544H275Z",
    transform: "translate(-219.803 -2299.887)",
    fill: "#f14a25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23935",
    "data-name": "Path 23935",
    d: "M251.251,2309.365l.5-.266,28.082,52.81h-.642Z",
    transform: "translate(-223.354 -2297.999)",
    fill: "#f14b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23936",
    "data-name": "Path 23936",
    d: "M255.3,2307.21l.5-.266,28.224,53.076h-.642Z",
    transform: "translate(-226.905 -2296.11)",
    fill: "#f14c25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23937",
    "data-name": "Path 23937",
    d: "M259.354,2305.056l.5-.266,28.365,53.342h-.642Z",
    transform: "translate(-230.456 -2294.222)",
    fill: "#f14d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23938",
    "data-name": "Path 23938",
    d: "M263.405,2302.9l.5-.266,28.506,53.608h-.642Z",
    transform: "translate(-234.007 -2292.333)",
    fill: "#f14e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23939",
    "data-name": "Path 23939",
    d: "M267.456,2300.748l.5-.266,28.648,53.874h-.641Z",
    transform: "translate(-237.558 -2290.445)",
    fill: "#f24f25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23940",
    "data-name": "Path 23940",
    d: "M271.508,2298.594l.5-.266,28.789,54.139h-.642Z",
    transform: "translate(-241.109 -2288.557)",
    fill: "#f25025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23941",
    "data-name": "Path 23941",
    d: "M275.559,2296.439l.5-.266,28.931,54.405h-.641Z",
    transform: "translate(-244.66 -2286.669)",
    fill: "#f25125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23942",
    "data-name": "Path 23942",
    d: "M279.61,2294.285l.5-.266,29.072,54.671h-.642Z",
    transform: "translate(-248.211 -2284.78)",
    fill: "#f25225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23943",
    "data-name": "Path 23943",
    d: "M283.661,2292.131l.5-.266,29.075,54.677-.488.26h-.015Z",
    transform: "translate(-251.762 -2282.892)",
    fill: "#f25325"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6116",
    "data-name": "Rectangle 6116",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 32.4, 8.972)",
    fill: "#f25425"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6117",
    "data-name": "Rectangle 6117",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 32.9, 8.706)",
    fill: "#f25525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6118",
    "data-name": "Rectangle 6118",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 33.4, 8.44)",
    fill: "#f25625"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6119",
    "data-name": "Rectangle 6119",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 33.9, 8.174)",
    fill: "#f25725"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6120",
    "data-name": "Rectangle 6120",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 34.4, 7.909)",
    fill: "#f35825"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6121",
    "data-name": "Rectangle 6121",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 34.9, 7.643)",
    fill: "#f35925"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6122",
    "data-name": "Rectangle 6122",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 35.4, 7.377)",
    fill: "#f35a25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6123",
    "data-name": "Rectangle 6123",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 35.9, 7.111)",
    fill: "#f35c25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6124",
    "data-name": "Rectangle 6124",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 36.4, 6.845)",
    fill: "#f35d25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6125",
    "data-name": "Rectangle 6125",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 36.901, 6.579)",
    fill: "#f35e26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6126",
    "data-name": "Rectangle 6126",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 37.401, 6.313)",
    fill: "#f35f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6127",
    "data-name": "Rectangle 6127",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 37.901, 6.047)",
    fill: "#f36026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6128",
    "data-name": "Rectangle 6128",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 38.401, 5.781)",
    fill: "#f46126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6129",
    "data-name": "Rectangle 6129",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 38.901, 5.515)",
    fill: "#f46226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6130",
    "data-name": "Rectangle 6130",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 39.401, 5.249)",
    fill: "#f46426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6131",
    "data-name": "Rectangle 6131",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 39.901, 4.983)",
    fill: "#f46526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6132",
    "data-name": "Rectangle 6132",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 40.401, 4.717)",
    fill: "#f46626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6133",
    "data-name": "Rectangle 6133",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 40.902, 4.451)",
    fill: "#f46726"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6134",
    "data-name": "Rectangle 6134",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 41.402, 4.185)",
    fill: "#f46826"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6135",
    "data-name": "Rectangle 6135",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 41.902, 3.919)",
    fill: "#f46a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6136",
    "data-name": "Rectangle 6136",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 42.402, 3.653)",
    fill: "#f56b26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6137",
    "data-name": "Rectangle 6137",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 42.902, 3.388)",
    fill: "#f56c26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6138",
    "data-name": "Rectangle 6138",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 43.402, 3.122)",
    fill: "#f56d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6139",
    "data-name": "Rectangle 6139",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 43.902, 2.856)",
    fill: "#f56f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6140",
    "data-name": "Rectangle 6140",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 44.402, 2.59)",
    fill: "#f57026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6141",
    "data-name": "Rectangle 6141",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 44.902, 2.324)",
    fill: "#f57126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6142",
    "data-name": "Rectangle 6142",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 45.403, 2.058)",
    fill: "#f57226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6143",
    "data-name": "Rectangle 6143",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 45.903, 1.792)",
    fill: "#f67426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6144",
    "data-name": "Rectangle 6144",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 46.403, 1.526)",
    fill: "#f67526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6145",
    "data-name": "Rectangle 6145",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 46.903, 1.26)",
    fill: "#f67626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6146",
    "data-name": "Rectangle 6146",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 47.403, 0.994)",
    fill: "#f67726"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6147",
    "data-name": "Rectangle 6147",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 47.903, 0.728)",
    fill: "#f67926"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6148",
    "data-name": "Rectangle 6148",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 48.403, 0.462)",
    fill: "#f67a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6149",
    "data-name": "Rectangle 6149",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 48.903, 0.196)",
    fill: "#f67b26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6150",
    "data-name": "Rectangle 6150",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 49.404, -0.07)",
    fill: "#f77d26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6151",
    "data-name": "Rectangle 6151",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 49.904, -0.336)",
    fill: "#f77e26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6152",
    "data-name": "Rectangle 6152",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 50.404, -0.602)",
    fill: "#f77f26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6153",
    "data-name": "Rectangle 6153",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 50.904, -0.868)",
    fill: "#f78126"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6154",
    "data-name": "Rectangle 6154",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 51.404, -1.133)",
    fill: "#f78226"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6155",
    "data-name": "Rectangle 6155",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 51.904, -1.399)",
    fill: "#f78426"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6156",
    "data-name": "Rectangle 6156",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 52.404, -1.665)",
    fill: "#f78526"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6157",
    "data-name": "Rectangle 6157",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 52.904, -1.931)",
    fill: "#f88626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6158",
    "data-name": "Rectangle 6158",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 53.404, -2.197)",
    fill: "#f88826"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6159",
    "data-name": "Rectangle 6159",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 53.905, -2.463)",
    fill: "#f88927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6160",
    "data-name": "Rectangle 6160",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 54.405, -2.729)",
    fill: "#f88a27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6161",
    "data-name": "Rectangle 6161",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 54.905, -2.995)",
    fill: "#f88c27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6162",
    "data-name": "Rectangle 6162",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 55.405, -3.261)",
    fill: "#f88d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6163",
    "data-name": "Rectangle 6163",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 55.905, -3.527)",
    fill: "#f98f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6164",
    "data-name": "Rectangle 6164",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 56.405, -3.793)",
    fill: "#f99027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6165",
    "data-name": "Rectangle 6165",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 56.905, -4.059)",
    fill: "#f99227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6166",
    "data-name": "Rectangle 6166",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 57.405, -4.325)",
    fill: "#f99327"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6167",
    "data-name": "Rectangle 6167",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 57.905, -4.591)",
    fill: "#f99427"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6168",
    "data-name": "Rectangle 6168",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 58.406, -4.857)",
    fill: "#f99627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6169",
    "data-name": "Rectangle 6169",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 58.906, -5.123)",
    fill: "#f99727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6170",
    "data-name": "Rectangle 6170",
    width: 0.566,
    height: 61.927,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 59.406, -5.389)",
    fill: "#fa9927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6171",
    "data-name": "Rectangle 6171",
    width: 0.566,
    height: 61.927,
    transform: "translate(59.906 -5.654) rotate(-28.001)",
    fill: "#fa9a27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6172",
    "data-name": "Rectangle 6172",
    width: 0.566,
    height: 61.927,
    transform: "translate(60.406 -5.92) rotate(-28.001)",
    fill: "#fa9c27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6173",
    "data-name": "Rectangle 6173",
    width: 0.566,
    height: 61.927,
    transform: "translate(60.906 -6.186) rotate(-28.001)",
    fill: "#fa9d27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6174",
    "data-name": "Rectangle 6174",
    width: 0.566,
    height: 61.927,
    transform: "translate(61.406 -6.452) rotate(-28.001)",
    fill: "#fa9f27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6175",
    "data-name": "Rectangle 6175",
    width: 0.566,
    height: 61.927,
    transform: "translate(61.906 -6.718) rotate(-28.001)",
    fill: "#faa027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6176",
    "data-name": "Rectangle 6176",
    width: 0.566,
    height: 61.927,
    transform: "translate(62.406 -6.984) rotate(-28.001)",
    fill: "#fba227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6177",
    "data-name": "Rectangle 6177",
    width: 0.566,
    height: 61.927,
    transform: "translate(62.907 -7.25) rotate(-28.001)",
    fill: "#fba327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23944",
    "data-name": "Path 23944",
    d: "M538.887,2157.032l.336-.179h.211l29.029,54.59-.5.266Z",
    transform: "translate(-475.481 -2164.548)",
    fill: "#fba527"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23945",
    "data-name": "Path 23945",
    d: "M543.955,2156.854l28.887,54.324-.5.266-29.029-54.59Z",
    transform: "translate(-479.361 -2164.548)",
    fill: "#fba627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23946",
    "data-name": "Path 23946",
    d: "M549.152,2156.854l28.746,54.058-.5.266-28.887-54.324Z",
    transform: "translate(-483.916 -2164.548)",
    fill: "#fba827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23947",
    "data-name": "Path 23947",
    d: "M554.349,2156.854l28.6,53.792-.5.266-28.746-54.058Z",
    transform: "translate(-488.472 -2164.548)",
    fill: "#fbaa27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23948",
    "data-name": "Path 23948",
    d: "M559.546,2156.854l28.463,53.526-.5.266-28.6-53.792Z",
    transform: "translate(-493.027 -2164.548)",
    fill: "#fcab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23949",
    "data-name": "Path 23949",
    d: "M564.742,2156.854l28.322,53.26-.5.266L564.1,2156.854Z",
    transform: "translate(-497.582 -2164.548)",
    fill: "#fcad27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23950",
    "data-name": "Path 23950",
    d: "M569.939,2156.854l28.18,52.995-.5.266-28.322-53.26Z",
    transform: "translate(-502.137 -2164.548)",
    fill: "#fcae27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23951",
    "data-name": "Path 23951",
    d: "M575.136,2156.854l28.039,52.729-.5.266-28.18-52.995Z",
    transform: "translate(-506.693 -2164.548)",
    fill: "#fcb027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23952",
    "data-name": "Path 23952",
    d: "M580.333,2156.854l27.9,52.462-.5.266-28.039-52.729Z",
    transform: "translate(-511.248 -2164.548)",
    fill: "#fcb127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23953",
    "data-name": "Path 23953",
    d: "M585.529,2156.854l27.507,51.728v.6l-.251.133-27.9-52.462Z",
    transform: "translate(-515.803 -2164.548)",
    fill: "#fcb327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23954",
    "data-name": "Path 23954",
    d: "M590.726,2156.854l26.865,50.521v1.207l-27.507-51.728Z",
    transform: "translate(-520.358 -2164.548)",
    fill: "#fdb528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23955",
    "data-name": "Path 23955",
    d: "M595.923,2156.854l26.224,49.315v1.206l-26.865-50.521Z",
    transform: "translate(-524.913 -2164.548)",
    fill: "#fdb628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23956",
    "data-name": "Path 23956",
    d: "M601.12,2156.854l25.582,48.108v1.207l-26.224-49.315Z",
    transform: "translate(-529.469 -2164.548)",
    fill: "#fdb828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23957",
    "data-name": "Path 23957",
    d: "M606.316,2156.854l24.94,46.9v1.206l-25.582-48.108Z",
    transform: "translate(-534.024 -2164.548)",
    fill: "#fdb928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23958",
    "data-name": "Path 23958",
    d: "M611.513,2156.854l24.3,45.7v1.207l-24.94-46.9Z",
    transform: "translate(-538.579 -2164.548)",
    fill: "#fdbb28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23959",
    "data-name": "Path 23959",
    d: "M616.71,2156.854l23.658,44.489v1.206l-24.3-45.7Z",
    transform: "translate(-543.134 -2164.548)",
    fill: "#febd28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23960",
    "data-name": "Path 23960",
    d: "M621.906,2156.854l23.016,43.283v1.206l-23.657-44.489Z",
    transform: "translate(-547.689 -2164.548)",
    fill: "#febe28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23961",
    "data-name": "Path 23961",
    d: "M627.1,2156.854l22.374,42.076v1.207l-23.016-43.283Z",
    transform: "translate(-552.245 -2164.548)",
    fill: "#fec028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23962",
    "data-name": "Path 23962",
    d: "M632.3,2156.854l21.733,40.87v1.207l-22.374-42.076Z",
    transform: "translate(-556.8 -2164.548)",
    fill: "#fec228"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23963",
    "data-name": "Path 23963",
    d: "M637.5,2156.854l21.091,39.663v1.206l-21.733-40.87Z",
    transform: "translate(-561.355 -2164.548)",
    fill: "#fec328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23964",
    "data-name": "Path 23964",
    d: "M642.693,2156.854l20.45,38.457v1.207l-21.091-39.663Z",
    transform: "translate(-565.91 -2164.548)",
    fill: "#fec528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23965",
    "data-name": "Path 23965",
    d: "M647.89,2156.854,667.7,2194.1v1.206l-20.45-38.457Z",
    transform: "translate(-570.465 -2164.548)",
    fill: "#ffc728"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23966",
    "data-name": "Path 23966",
    d: "M653.087,2156.854l19.167,36.044v1.207l-19.808-37.25Z",
    transform: "translate(-575.021 -2164.548)",
    fill: "#ffc828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23967",
    "data-name": "Path 23967",
    d: "M658.284,2156.854l18.525,34.838v1.206l-19.167-36.044Z",
    transform: "translate(-579.576 -2164.548)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23968",
    "data-name": "Path 23968",
    d: "M681.364,2191.691l-18.525-34.838h18.525Z",
    transform: "translate(-584.131 -2164.548)",
    fill: "#ffca28"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7637",
    "data-name": "Group 7637",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7636",
    "data-name": "Group 7636",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7539",
    "data-name": "Group 7539",
    transform: "translate(3.119 273.955)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7538",
    "data-name": "Group 7538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7537",
    "data-name": "Group 7537",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23970",
    "data-name": "Path 23970",
    d: "M42.626,2268.329c17.349-15.047,14.749-32.626,33.781-40.886,23.818-10.336,39.8,12.99,39.8,12.99a37.967,37.967,0,0,1,.681,6.315,42.39,42.39,0,0,0-.51-11.935s-15.982-23.326-39.8-12.99-13.753,35.27-51.312,51.569a65.614,65.614,0,0,1,17.36-5.063",
    transform: "translate(-25.266 -2219.181)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7542",
    "data-name": "Group 7542",
    transform: "translate(3.119 307.156)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7541",
    "data-name": "Group 7541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7540",
    "data-name": "Group 7540",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23971",
    "data-name": "Path 23971",
    d: "M115.935,2488.125a29.034,29.034,0,0,1-13.428,11.229c-19.7,8.549-31.342-7.756-56.029-4.428-4.771,5.052-11.348,9.929-21.213,14.21,37.559-16.3,49.6,9.7,73.415-.638a28.907,28.907,0,0,0,17.255-20.373",
    transform: "translate(-25.265 -2488.125)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23972",
    "data-name": "Path 23972",
    d: "M266.168,2288.622c21.866-9.49,36.662,5.639,50.528-.379s8.855-25.424,8.855-25.424-10.752-16.915-24.618-10.9-12.9,27.21-34.765,36.7",
    transform: "translate(-233.31 -1972.79)",
    fill: "#ffd553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23973",
    "data-name": "Path 23973",
    d: "M64.552,2263.046c-5.866,0-11.346-1.584-17.014-3.222-11.467-3.314-24.464-7.069-44.7,1.714a2.027,2.027,0,1,1-1.614-3.718c20.268-8.8,26.595-20.427,32.176-30.689,4.644-8.537,9.029-16.6,20.228-21.46,10.392-4.511,21.024-3.55,30.744,2.779A44.643,44.643,0,0,1,95.9,2219.374a2.029,2.029,0,0,1,.307.707,44.637,44.637,0,0,1,.1,15.886c-2.017,11.422-8.576,19.843-18.968,24.353a31.513,31.513,0,0,1-12.789,2.727M26.684,2252.02c8.445,0,15.446,2.024,21.979,3.911,9.215,2.663,17.175,4.963,27.065.672,20.562-8.924,17.186-32.017,16.6-35.264-2.047-2.8-16.341-20.954-37.088-11.948-9.918,4.3-13.794,11.429-18.281,19.679-4.169,7.665-8.731,16.052-18.668,23.615a53.973,53.973,0,0,1,8.4-.663",
    transform: "translate(0 -1930.932)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23974",
    "data-name": "Path 23974",
    d: "M734.778,2135.368l-10.012,1.558a12.461,12.461,0,0,1-11.848-4.789,74.8,74.8,0,0,1-14.769-37.386h0a12.461,12.461,0,0,1,5.376-11.593l8.373-5.705",
    transform: "translate(-611.904 -1820.994)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7545",
    "data-name": "Group 7545",
    transform: "translate(86.176 257.693)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7544",
    "data-name": "Group 7544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7543",
    "data-name": "Group 7543",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23975",
    "data-name": "Path 23975",
    d: "M713.667,2091.955l-8.292,5.651a13.767,13.767,0,0,0-5.942,12.819q.3,2.917.816,5.8a74.543,74.543,0,0,1-2.113-11.476,12.468,12.468,0,0,1,5.376-11.593l8.375-5.7Z",
    transform: "translate(-698.068 -2087.448)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7548",
    "data-name": "Group 7548",
    transform: "translate(92.553 256.458)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7547",
    "data-name": "Group 7547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7546",
    "data-name": "Group 7546",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23976",
    "data-name": "Path 23976",
    d: "M749.725,2115.579h0a74.829,74.829,0,0,0,7.226,11.618,12.454,12.454,0,0,0,11.848,4.786l9.336-1.453-20.969-53.082-1.788,1.219,15.547,39.351-10.015,1.56a12.451,12.451,0,0,1-11.186-4m19.292-2.395-13.638-34.518.565-.385,13.748,34.8Z",
    transform: "translate(-749.725 -2077.448)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23977",
    "data-name": "Path 23977",
    d: "M595.018,1857.13c-5.2-10.2-23.039-23.69-58.121-1.429a.6.6,0,0,0,.215,1.1c5.838,1.041,33.3,5.72,38.328,20",
    transform: "translate(-470.374 -1616.054)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7551",
    "data-name": "Group 7551",
    transform: "translate(66.245 226.979)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7550",
    "data-name": "Group 7550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7549",
    "data-name": "Group 7549",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23978",
    "data-name": "Path 23978",
    d: "M542.8,1852.893c-2.518-.538-4.534-.889-5.692-1.1a.6.6,0,0,1-.216-1.1c35.082-22.262,52.917-8.769,58.122,1.429l-2.121,2.129c-6.728-8.688-22.546-16.613-50.093-1.366",
    transform: "translate(-536.618 -1838.649)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23979",
    "data-name": "Path 23979",
    d: "M558.837,1862.372a2.338,2.338,0,0,1-2.2-1.562c-1.68-4.774-8.626-13.516-36.257-18.427l-.277-.049a2.938,2.938,0,0,1-1.057-5.372c17.054-10.822,31.924-14.609,44.194-11.256a27.167,27.167,0,0,1,17.262,13.6,2.337,2.337,0,1,1-4.164,2.125A22.468,22.468,0,0,0,562,1830.215c-9.907-2.708-22.506.186-36.627,8.368,25.173,5.206,33.325,14.025,35.666,20.675a2.339,2.339,0,0,1-2.2,3.114",
    transform: "translate(-453.771 -1599.288)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23980",
    "data-name": "Path 23980",
    d: "M924.973,2484.869c3.17,11-.393,33.634-41.218,41.36a.6.6,0,0,1-.593-.948c3.55-4.75,20.152-27.564,14.061-41.427",
    transform: "translate(-774.032 -2177.224)",
    fill: "#d25658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23981",
    "data-name": "Path 23981",
    d: "M883.769,2526.234a.6.6,0,0,1-.592-.951A107.41,107.41,0,0,0,894.1,2507.4c3.653-7.825,6.069-16.646,3.2-23.388-.019-.049-.044-.1-.063-.149l.168.005,27.581,1.008a24.64,24.64,0,0,1,.4,11.428c-2.163,11.106-12.247,24.374-41.614,29.935",
    transform: "translate(-774.043 -2177.229)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7554",
    "data-name": "Group 7554",
    transform: "translate(120.054 306.635)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7553",
    "data-name": "Group 7553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7552",
    "data-name": "Group 7552",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23982",
    "data-name": "Path 23982",
    d: "M972.5,2507.433c3.653-7.825,6.069-16.646,3.2-23.388.036-.046.069-.1.1-.144l27.582,1.008a24.64,24.64,0,0,1,.4,11.428c-6.581,5.584-16.557,9.97-31.285,11.1",
    transform: "translate(-972.5 -2483.901)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23983",
    "data-name": "Path 23983",
    d: "M867.025,2511.977a2.939,2.939,0,0,1-2.343-4.7c4.575-6.121,19.091-27.028,13.792-39.087a2.337,2.337,0,0,1,4.28-1.881c5.391,12.271-4.82,30.162-11.7,40.1,15.687-3.643,26.759-10.142,32.162-18.924a23.558,23.558,0,0,0,2.9-18.578,2.337,2.337,0,0,1,4.492-1.294,27.913,27.913,0,0,1-3.408,22.322c-6.693,10.877-20.023,18.273-39.621,21.982a2.976,2.976,0,0,1-.556.052m-.312-4.646h0",
    transform: "translate(-757.422 -2160.624)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23984",
    "data-name": "Path 23984",
    d: "M1021.057,1513.813s-9.174,58.358-84.758,94.405c-64.394,30.707-108.914,15.578-108.914,15.578a89.671,89.671,0,0,1-22.877-57.919s9.887-18.512,36.731-37.234c.923-.643,1.87-1.291,2.834-1.934a192.976,192.976,0,0,1,39.028-19.873q5.539-2.1,11.552-4.014c.158-.053.315-.1.473-.146a186.707,186.707,0,0,1,44.292-8.514c.427-.029.847-.052,1.268-.076,51.4-2.875,80.369,19.727,80.369,19.727",
    transform: "translate(-705.192 -1309.421)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23985",
    "data-name": "Path 23985",
    d: "M2010.765,1577.927a216.21,216.21,0,0,0-33.2-84.03c46.418-.31,72.411,19.969,72.411,19.969s-5.118,32.563-39.216,64.06",
    transform: "translate(-1733.44 -1309.474)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7557",
    "data-name": "Group 7557",
    transform: "translate(244.129 183.801)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7556",
    "data-name": "Group 7556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7555",
    "data-name": "Group 7555",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23986",
    "data-name": "Path 23986",
    d: "M2049.018,1513.1c.722-2.71.962-4.238.962-4.238s-25.992-20.279-72.411-19.969q1.632,2.456,3.195,4.953c39.347.54,63.3,15.783,68.254,19.254",
    transform: "translate(-1977.569 -1488.894)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23987",
    "data-name": "Path 23987",
    d: "M1978.346,1565.982l-.714-4.267a212.483,212.483,0,0,0-32.837-83.121l-2.395-3.6,4.326-.029c36.794-.254,61.094,12.327,69.837,17.744a8.645,8.645,0,0,1,3.816,9.662c-2.682,9.929-11.836,35.717-38.856,60.677Zm-27.274-86.313a216.873,216.873,0,0,1,30.408,76.971c23.712-23.171,31.917-46.343,34.387-55.49a4,4,0,0,0-1.766-4.47c-8.054-4.99-29.885-16.3-63.029-17.012",
    transform: "translate(-1702.613 -1292.877)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23988",
    "data-name": "Path 23988",
    d: "M846.073,1613.286c-19.087,0-30.175-3.694-30.642-3.853l-.579-.2-.409-.456a91.949,91.949,0,0,1-23.475-59.425l-.013-.612.288-.54c.234-.437,5.887-10.863,20.048-24.042,12.984-12.085,35.92-28.858,71.454-40.141a185.055,185.055,0,0,1,54.68-9.089l1.263-.008.7,1.051a217.129,217.129,0,0,1,33.518,84.721l.464,1.26-1.145,1.065a185.052,185.052,0,0,1-46.129,30.735c-33.651,16.048-61.859,19.477-79.6,19.529h-.427M817.5,1605.18c2.474.73,12.958,3.523,29.24,3.43,17.208-.079,44.6-3.453,77.348-19.072a181.1,181.1,0,0,0,44.036-29.095,212.407,212.407,0,0,0-31.928-80.822,181.079,181.079,0,0,0-52.033,8.856c-62.265,19.772-85.695,56.656-88.5,61.422A87.272,87.272,0,0,0,817.5,1605.18",
    transform: "translate(-693.312 -1292.847)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23989",
    "data-name": "Path 23989",
    d: "M706.241,2122.82a14.775,14.775,0,0,1-11.786-5.864,77.134,77.134,0,0,1-15.231-38.554,14.779,14.779,0,0,1,6.385-13.768l8.373-5.705a2.337,2.337,0,1,1,2.632,3.863l-8.373,5.705a10.11,10.11,0,0,0-4.368,9.418,72.465,72.465,0,0,0,14.308,36.219,10.109,10.109,0,0,0,9.626,3.889l10.012-1.557a2.338,2.338,0,0,1,.719,4.62l-10.012,1.558a14.934,14.934,0,0,1-2.285.177",
    transform: "translate(-595.304 -1804.401)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7560",
    "data-name": "Group 7560",
    transform: "translate(189.602 213.365)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7559",
    "data-name": "Group 7559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7558",
    "data-name": "Group 7558",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23990",
    "data-name": "Path 23990",
    d: "M1579.845,1790.431a32.151,32.151,0,1,1,18.09-41.716,32.152,32.152,0,0,1-18.09,41.716",
    transform: "translate(-1535.872 -1728.369)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23991",
    "data-name": "Path 23991",
    d: "M1607.419,1778.239a28.912,28.912,0,1,1,16.267-37.513,28.912,28.912,0,0,1-16.267,37.513",
    transform: "translate(-1374.324 -1509.797)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7563",
    "data-name": "Group 7563",
    transform: "translate(193.553 213.249)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7562",
    "data-name": "Group 7562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7561",
    "data-name": "Group 7561",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23992",
    "data-name": "Path 23992",
    d: "M1625.239,1751.1c-.2-.627-.417-1.247-.661-1.866a28.914,28.914,0,0,0-55.318,15.905,28.912,28.912,0,0,1,54.434-19.412,29.22,29.22,0,0,1,1.546,5.373",
    transform: "translate(-1567.883 -1727.426)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7566",
    "data-name": "Group 7566",
    transform: "translate(193.556 237.214)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7565",
    "data-name": "Group 7565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7564",
    "data-name": "Group 7564",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23993",
    "data-name": "Path 23993",
    d: "M1607.437,1952.784a28.91,28.91,0,0,1-39.312-30.454,28.913,28.913,0,0,0,57.28-.772,28.92,28.92,0,0,1-17.968,31.226",
    transform: "translate(-1567.9 -1921.558)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23994",
    "data-name": "Path 23994",
    d: "M1580.126,1765.954a31.326,31.326,0,1,1,11.489-2.2,31.175,31.175,0,0,1-11.489,2.2m.013-57.856a26.632,26.632,0,1,0,10.567,2.208,26.554,26.554,0,0,0-10.567-2.208",
    transform: "translate(-1357.661 -1493.136)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23995",
    "data-name": "Path 23995",
    d: "M1679.83,1839.548a18.393,18.393,0,1,1,10.349-23.865,18.394,18.394,0,0,1-10.349,23.865",
    transform: "translate(-1450.406 -1581.336)",
    fill: "#d50511"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7569",
    "data-name": "Group 7569",
    transform: "translate(204.278 234.929)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7568",
    "data-name": "Group 7568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7567",
    "data-name": "Group 7567",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23996",
    "data-name": "Path 23996",
    d: "M1679.906,1926.335a18.393,18.393,0,0,1-23.864-10.352,18.194,18.194,0,0,1-1.281-6.232c.067.193.14.383.215.579a18.4,18.4,0,0,0,35.5-7.281,18.4,18.4,0,0,1-10.567,23.285",
    transform: "translate(-1654.761 -1903.05)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7572",
    "data-name": "Group 7572",
    transform: "translate(204.47 223.298)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7571",
    "data-name": "Group 7571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7570",
    "data-name": "Group 7570",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23997",
    "data-name": "Path 23997",
    d: "M1693.1,1827.591c-.1-.3-.209-.595-.328-.893a18.394,18.394,0,0,0-35.5,6.4,18.394,18.394,0,1,1,35.826-5.507",
    transform: "translate(-1656.308 -1808.834)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23998",
    "data-name": "Path 23998",
    d: "M1656.5,1826.616a20.757,20.757,0,1,1,7.622-1.461,20.683,20.683,0,0,1-7.622,1.461m-.014-36.8a16.056,16.056,0,1,0,14.952,10.157,15.966,15.966,0,0,0-14.952-10.157",
    transform: "translate(-1433.84 -1564.769)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7575",
    "data-name": "Group 7575",
    transform: "translate(259.684 193.876)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7574",
    "data-name": "Group 7574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7573",
    "data-name": "Group 7573",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23999",
    "data-name": "Path 23999",
    d: "M2126.581,1578.3c-.139-4.391-9.262-7.833-14.424-7.792-5.346.042-8.562.963-8.585,3.551-.032,3.614,4.132,4.887,9.081,5.075,3.5.133,14.1,4.586,13.928-.833",
    transform: "translate(-2103.571 -1570.503)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7578",
    "data-name": "Group 7578",
    transform: "translate(284.701 199.505)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7576",
    "data-name": "Group 7576",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24000",
    "data-name": "Path 24000",
    d: "M2317.612,1623.814c-.287-3.806-4.888-7.352-7.393-7.639-2.594-.3-4.11.3-3.992,2.534.165,3.123,2.25,4.484,4.663,4.956,1.706.333,7.075,4.846,6.722.149",
    transform: "translate(-2306.221 -1616.103)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7581",
    "data-name": "Group 7581",
    transform: "translate(99.995 200.649)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7580",
    "data-name": "Group 7580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7579",
    "data-name": "Group 7579",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24001",
    "data-name": "Path 24001",
    d: "M831.653,1734.761s44.52,15.129,108.91-15.574c65.392-31.185,81.073-79.061,84.114-91.412q.464.31.814.555c-.948-.66-2.522-1.7-4.709-2.974-8.878,20.177-30.013,52.64-78.691,75.855-30.4,14.5-56.378,18.778-75.325,19.256a53.519,53.519,0,0,1-52.812-38.135q-.057-.192-.112-.384c-.268-.921-.516-1.85-.754-2.781-.123-.385-.253-.766-.368-1.155q-.056-.192-.112-.385c-.04-.137-.074-.276-.114-.413l.086-.126h0c-1.766,2.576-2.57,4.078-2.57,4.078a78.029,78.029,0,0,0,21.643,53.595",
    transform: "translate(-810.01 -1625.356)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24002",
    "data-name": "Path 24002",
    d: "M743.52,2219.528c-13.256,5.233-30.453-.1-30.453-.1s.034-.06.1-.165c1-1.7,9.612-15.8,22.056-20.724,11.944-4.721,24.953.125,27.27,1.069.238.1.362.153.362.153s-6.167,14.576-19.335,19.771",
    transform: "translate(-625.04 -1925.344)",
    fill: "#ec1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7584",
    "data-name": "Group 7584",
    transform: "translate(88.643 271.772)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7583",
    "data-name": "Group 7583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7582",
    "data-name": "Group 7582",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24003",
    "data-name": "Path 24003",
    d: "M767.841,2204.755s-.377.888-1.137,2.3c-4.432-1.534-15.4-4.478-25.6-.445-10.008,3.957-17.538,13.855-20.625,18.455-1.533-.363-2.427-.639-2.427-.639s.037-.06.1-.168c1-1.694,9.614-15.8,22.059-20.722,11.943-4.723,24.949.124,27.266,1.068.242.1.366.151.366.151",
    transform: "translate(-718.049 -2201.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7587",
    "data-name": "Group 7587",
    transform: "translate(88.027 274.259)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7586",
    "data-name": "Group 7586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7585",
    "data-name": "Group 7585",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24004",
    "data-name": "Path 24004",
    d: "M743.52,2241.563c-13.256,5.233-30.453-.1-30.453-.1s.034-.061.1-.165l49.326-19.656c.238.1.362.154.362.154s-6.167,14.576-19.335,19.771",
    transform: "translate(-713.067 -2221.639)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24005",
    "data-name": "Path 24005",
    d: "M705.232,2207.52a65.032,65.032,0,0,1-17.5-2.518l-2.776-.862,1.438-2.527c.38-.668,9.473-16.427,23.331-21.906,13.918-5.5,28.81.98,29.436,1.259l2.1.932-.894,2.114c-.267.632-6.707,15.542-20.629,21.037a39.782,39.782,0,0,1-14.506,2.471m-13.1-6.216c5.337,1.195,16.746,3.006,25.888-.6s14.732-12.241,16.944-16.312c-4.405-1.455-14.406-3.937-23.52-.334-9.162,3.622-16.238,12.732-19.312,17.249m-3.706,1.466h0Z",
    transform: "translate(-600.401 -1908.69)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24006",
    "data-name": "Path 24006",
    d: "M1351.247,1830.173c.236-.269.461-.537.667-.8-.384.431-.6.708-.667.8",
    transform: "translate(-1184.437 -1603.536)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24007",
    "data-name": "Path 24007",
    d: "M612.581,994.191q-2.2,58.714,12.46,72.093-29.711,20.709-36.18,5.818c-28.027-49.216-30.1-74.393-9.707-84.253,10.538-5.1,19.937-5.61,33.427,6.342",
    transform: "translate(-495.761 -862.908)",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24008",
    "data-name": "Path 24008",
    d: "M580.414,1065.512a11.437,11.437,0,0,1-7.469-6.828c-19.661-34.543-26.7-57.436-22.162-72.045,2.046-6.581,6.544-11.591,13.369-14.893,10.917-5.279,21.15-6.169,35.612,6.644a1.99,1.99,0,0,1,.668,1.564c-1.437,38.349,2.537,62.084,11.813,70.549a1.988,1.988,0,0,1-.2,3.1c-11.925,8.312-21.092,12.4-27.844,12.4a13.833,13.833,0,0,1-3.785-.5m16.009-84.758C583.951,970,575.46,970.7,565.884,975.328c-5.876,2.841-9.573,6.928-11.3,12.492-4.137,13.312,3.017,35.877,21.871,68.986a2.023,2.023,0,0,1,.1.192,7.575,7.575,0,0,0,4.949,4.687c3.732,1.056,11.309.113,26.339-10.021-9-10.388-12.734-33.652-11.415-70.911",
    transform: "translate(-481.626 -848.596)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24009",
    "data-name": "Path 24009",
    d: "M750.459,548.255q-30.941,5.536-53.667,15.9,7.418,33.019-19.56,52.1a16.734,16.734,0,1,1-19.606,26.866c-23.273-23.211-26.008-35.437-13.3-45.065,14.4-10.914,13.64-20.938,4.329-22.819q-23.274-7.078-21.7-51.435-14.657,9.993-14.116,26.72,14.279,18.038-3.494,13.916c-6.7,20.293-32.257,14.483-28.564-10.9,5.521-37.905,23.5-56.492,47.4-56.9q55.353,2.025,72.567-25.081c26.46-10.144,47.7-28.574,66.347-53.377,1.748-2.326,5.7-1.032,7.64,1.133s1.631,5.135.294,7.718a45.778,45.778,0,0,1-8.369,12.141c18.8,10.871,21.521,19.67,6.99,24.756,2.309,9.4-12.715,23.22-54.111,32.722a130.127,130.127,0,0,1,18.052,36.527q10.206,5.785,12.871,15.07",
    transform: "translate(-508.763 -365.482)",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24010",
    "data-name": "Path 24010",
    d: "M642.11,630.478c-.021-.019-.041-.037-.06-.057-15.368-15.327-21.959-26.038-21.369-34.73.34-5.01,3.045-9.37,8.269-13.329,8.6-6.52,10.905-12.177,10.192-15.3-.587-2.569-3.073-3.586-5.057-3.987a1.756,1.756,0,0,1-.184-.046c-15.657-4.761-23.453-21.329-23.2-49.272a26.746,26.746,0,0,0-10.062,21.947c5.784,7.415,7.531,12.054,5.665,15-1.811,2.86-6.154,2.635-9.858,1.929-4.063,10.045-12.575,13.072-19.071,11.539-7.881-1.859-14.875-10.318-12.734-25.026,2.74-18.813,8.551-33.458,17.272-43.527a42.377,42.377,0,0,1,32.062-15.079c.034,0,.072,0,.107,0,35.971,1.322,59.8-6.812,70.814-24.159a1.991,1.991,0,0,1,.967-.791c24.428-9.365,45.842-26.608,65.469-52.715a5.145,5.145,0,0,1,3.982-2.022,9.139,9.139,0,0,1,6.729,3.023c2.275,2.541,2.491,6.264.579,9.96a51.654,51.654,0,0,1-6.99,10.779c10.632,6.478,15.567,12.208,15.071,17.482-.35,3.722-3.385,6.753-9.029,9.022a12.743,12.743,0,0,1-2.1,7.389c-6.142,9.97-24.407,18.977-51.547,25.454,1.958,5.156,4.018,10.2,6.137,15.027,1.425,3.244,2.142,4.725,2.608,5.652a85.173,85.173,0,0,0,7.99,12.9c7.033,4.079,11.555,9.476,13.441,16.044a1.989,1.989,0,0,1-1.562,2.507c-19.708,3.526-37.1,8.605-51.737,15.1,4.258,21.083-1.931,38.182-18.411,50.889a18.72,18.72,0,0,1-4.786,31.985,18.608,18.608,0,0,1-6.9,1.319,18.8,18.8,0,0,1-12.7-4.913M722.437,520.8a2,2,0,0,1-.6-.527,89.1,89.1,0,0,1-8.619-13.844c-.487-.97-1.234-2.511-2.7-5.839-2.438-5.553-4.8-11.391-7.018-17.353a1.989,1.989,0,0,1,1.42-2.632c38.228-8.775,48.585-19.833,51.263-24.18a8,8,0,0,0,1.361-6.128,1.989,1.989,0,0,1,1.275-2.351c3.461-1.212,7.646-3.274,7.922-6.218.2-2.169-1.506-6.994-15.251-14.94a1.989,1.989,0,0,1-.408-3.131,43.632,43.632,0,0,0,8.006-11.647c.67-1.294,1.559-3.726-.009-5.476a5.112,5.112,0,0,0-3.594-1.7,1.143,1.143,0,0,0-.975.438c-19.927,26.507-41.723,44.113-66.617,53.8-11.965,18.235-36.815,26.8-73.905,25.449-24.166.446-40.293,20.047-45.413,55.2-1.778,12.215,3.6,19.139,9.711,20.581,5.31,1.252,12-1.538,15-10.6a1.989,1.989,0,0,1,2.338-1.314c6.412,1.486,7.312.2,7.321.184.051-.08,1.171-2.077-5.836-10.928a1.989,1.989,0,0,1-.429-1.17c-.383-11.824,4.658-21.388,14.983-28.428a1.989,1.989,0,0,1,3.109,1.714c-1.006,28.362,5.792,44.994,20.2,49.435,4.309.9,7.239,3.439,8.048,6.98,1.3,5.694-2.952,12.748-11.668,19.355-4.312,3.268-6.442,6.581-6.7,10.428-.5,7.336,5.913,17.382,20.179,31.614a14.745,14.745,0,1,0,17.246-23.7,1.989,1.989,0,0,1-.163-3.351c17.425-12.327,23.564-28.7,18.768-50.044a1.989,1.989,0,0,1,1.115-2.245c14.669-6.692,32.1-11.949,51.854-15.635-1.943-4.717-5.706-8.679-11.213-11.8",
    transform: "translate(-494.593 -351.364)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24011",
    "data-name": "Path 24011",
    d: "M1505.952,931.555a1.989,1.989,0,0,0,1.538-3.249c-6.646-8.118-13.751-14.108-21.119-17.8a1.989,1.989,0,1,0-1.784,3.555c6.866,3.444,13.535,9.086,19.825,16.767a1.985,1.985,0,0,0,1.54.729",
    transform: "translate(-1300.354 -797.917)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24012",
    "data-name": "Path 24012",
    d: "M619.935,1033.23a1.99,1.99,0,0,0,1.822-2.785c-2.174-4.982-5.27-8.243-9.2-9.692-4.486-1.654-10.024-.9-16.458,2.234a1.989,1.989,0,0,0,1.743,3.576c5.42-2.642,9.908-3.339,13.339-2.076,2.875,1.059,5.207,3.6,6.931,7.55a1.989,1.989,0,0,0,1.824,1.194",
    transform: "translate(-521.529 -893.995)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24013",
    "data-name": "Path 24013",
    d: "M875.364,1555.163a1.992,1.992,0,0,0,1.88-2.64c-1.943-5.615-5.855-11.965-11.626-18.876a1.989,1.989,0,1,0-3.054,2.55c5.462,6.54,9.136,12.47,10.921,17.627a1.99,1.99,0,0,0,1.88,1.339",
    transform: "translate(-755.675 -1343.695)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24014",
    "data-name": "Path 24014",
    d: "M1274.969,1102.362l-47.843,17.543a11,11,0,0,1-14.079-6.525l-9.334-25.46a11.011,11.011,0,0,1,4.543-13.115,10.658,10.658,0,0,1,1.982-.964l47.836-17.54a11,11,0,0,1,14.079,6.525l7.4,20.164,1.944,5.294a11.005,11.005,0,0,1-6.525,14.079",
    transform: "translate(-1054.53 -925.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24015",
    "data-name": "Path 24015",
    d: "M1274.969,1102.362l-47.843,17.543a11,11,0,0,1-14.079-6.525l-9.334-25.46a11.011,11.011,0,0,1,4.543-13.115,10.658,10.658,0,0,1,1.982-.964l47.836-17.54a11,11,0,0,1,14.079,6.525l7.4,20.164,1.944,5.294a11.005,11.005,0,0,1-6.525,14.079",
    transform: "translate(-1054.53 -925.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24016",
    "data-name": "Path 24016",
    d: "M1258,1210.815l-.029.216-30.828,11.3a11,11,0,0,1-11.591-2.621,10.714,10.714,0,0,1-2.48-3.907l-4.152-11.309-1.37-3.733-2.4-6.555-1.418-3.861a11,11,0,0,1,6.522-14.08l10.339-3.786a11,11,0,0,0-4.689,13.187l2.768,7.559,2.276,6.2,4.292,11.72a11.021,11.021,0,0,0,14.08,6.522Z",
    transform: "translate(-1054.548 -1027.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24017",
    "data-name": "Path 24017",
    d: "M1398.343,1270.712c.34.943,1.757,9.038,1.757,9.038l-5.375,1.936c-3.7,1.333-8.082-1.418-9.785-6.146s-.083-9.641,3.619-10.974l5.375-1.936s3.856,6.545,4.41,8.082",
    transform: "translate(-1213.376 -1106.76)",
    fill: "#22a7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24018",
    "data-name": "Path 24018",
    d: "M702.421,1223.8a1.659,1.659,0,0,0,1.525-2.306c-4.3-10.126-12.866-16.008-25.474-17.485a1.658,1.658,0,1,0-.386,3.292c11.5,1.346,18.959,6.412,22.809,15.487a1.659,1.659,0,0,0,1.526,1.011",
    transform: "translate(-593.093 -1055.366)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24019",
    "data-name": "Path 24019",
    d: "M1705.914,808.992a1.658,1.658,0,0,0,.245-3.3c-12.988-1.957-18.67-10.873-17.369-27.256a1.657,1.657,0,1,0-3.3-.263c-1.445,18.2,5.344,28.562,20.179,30.8a1.68,1.68,0,0,0,.249.019",
    transform: "translate(-1477.247 -680.773)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24020",
    "data-name": "Path 24020",
    d: "M1928.221,599.629c2.346-.677,4.68-1.409,6.989-2.252A40.855,40.855,0,0,0,1942,594.3a11.212,11.212,0,0,0,3.105-2.551,4.41,4.41,0,0,0,.969-2.231,3.9,3.9,0,0,0-.664-2.528,9.428,9.428,0,0,0-3.239-2.742,28.148,28.148,0,0,0-3.5-1.638l-.083,2.945a41.384,41.384,0,0,0,5.706-1.76,16.142,16.142,0,0,0,2.853-1.494,10.4,10.4,0,0,0,2.561-2.394,1.982,1.982,0,0,0-3.107-2.461l-.161.193a7.727,7.727,0,0,1-1.648,1.395,12.7,12.7,0,0,1-2.165,1.1c-.785.325-1.63.582-2.484.865s-1.745.525-2.647.769a2.384,2.384,0,0,0-.235,4.525l.106.04a27.182,27.182,0,0,1,3.029,1.3,10.4,10.4,0,0,1,1.246.757,4.822,4.822,0,0,1,.766.7c.125.189.1.167.113.16a.943.943,0,0,1-.22.468,8.7,8.7,0,0,1-2.067,1.881,26.312,26.312,0,0,1-2.9,1.734l-3.124,1.63a43.873,43.873,0,0,0-6.26,3.875l-.1.078a.41.41,0,0,0,.364.718",
    transform: "translate(-1689.725 -505.544)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24021",
    "data-name": "Path 24021",
    d: "M2019.507,719.942a17.549,17.549,0,0,0,6.65-1.395,1.989,1.989,0,0,0-1.5-3.683c-6.4,2.612-12.068.423-17.313-6.694a1.989,1.989,0,1,0-3.2,2.36c4.618,6.264,9.766,9.411,15.367,9.411",
    transform: "translate(-1756.391 -620.039)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24022",
    "data-name": "Path 24022",
    d: "M943.123,1202.185a49.725,49.725,0,0,0-2.615,17.193,1.968,1.968,0,0,0,3.931.068l.028-.45c.084-1.351.137-2.686.181-4.023l.152-4.02c.077-1.343.129-2.695.175-4.066a38.176,38.176,0,0,0-.1-4.237l-.027-.274a.889.889,0,0,0-1.729-.191",
    transform: "translate(-824.382 -1053.242)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7590",
    "data-name": "Group 7590",
    transform: "translate(108.15 101.144)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7589",
    "data-name": "Group 7589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7588",
    "data-name": "Group 7588",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24023",
    "data-name": "Path 24023",
    d: "M882.24,848.7c-2.635.347-4.787.677-6.168.9a75.368,75.368,0,0,0,54.885,3.826,70.306,70.306,0,0,0,41.479-34.1q-10.093,2.764-10.092,2.766c-12.777,17.285-24.7,22.536-33.273,24.112-10.733,1.972-21.639-.817-46.83,2.5",
    transform: "translate(-876.072 -819.321)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7593",
    "data-name": "Group 7593",
    transform: "translate(69.896 147.01)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7592",
    "data-name": "Group 7592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7591",
    "data-name": "Group 7591",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24024",
    "data-name": "Path 24024",
    d: "M614.337,1203.14q3.688-8.258,1.948-12.276c-13.572,9.638-21.792,23.474-21.3,37.123-.35,2.487,2.442,5.974,6.125,9.217q5.859,6.022-3.909,5.614-20.5,14.776-31.006-5.508,11.2,29.83,29.062,9.708,2.488-2.725,10.437-3.818,5.25-3.695-4.811-14.3.042-17,13.454-25.764",
    transform: "translate(-566.195 -1190.863)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7596",
    "data-name": "Group 7596",
    transform: "translate(203.624 85.183)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7595",
    "data-name": "Group 7595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7594",
    "data-name": "Group 7594",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24025",
    "data-name": "Path 24025",
    d: "M1655.946,736.154a9.716,9.716,0,0,1-4.322-1.346,8.1,8.1,0,0,1-2.169-2.126q45.469-11.42,51.493-27.292-5.159-1.985-6.738-5.834a8.516,8.516,0,0,1-5.658,1.113,8.416,8.416,0,0,1-4.356-2.138,29.614,29.614,0,0,0,15.185-7.807c5.673,6.137,12.971,7.648,16.9,4.873.678-.479,2.489-1.956,3.227-5.571q1.8,9.774-8.746,13.335a23.135,23.135,0,0,1-2.541,10.126c-2.869,5.461-6.507,6.517-27.183,16.133,0,0-15.388,7.157-25.092,6.534",
    transform: "translate(-1649.455 -690.026)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7599",
    "data-name": "Group 7599",
    transform: "translate(122.6 147.543)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7598",
    "data-name": "Group 7598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7597",
    "data-name": "Group 7597",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24026",
    "data-name": "Path 24026",
    d: "M1016.377,1268.881q3.984-8.971-2.2-11.833-16.316-4.446-21.054-20.285a91.082,91.082,0,0,0,30.593-7.131q4.917-4.346,13.18,5.791,9.417,8.791,24.635,2.851c-.278.032-.555.06-.828.08q-23.315-11.756-25.867-40.571c5.067-3.343,3.8-2.508,3.8-2.508,10.316,34.853,31.877,37.526,62.261,19.091q-5.029,4.551-9.645,8.235,11.323,3.224,10.852,9.7-27.43,6.35-39.2,12.154a18.176,18.176,0,0,1-2.719,4.372q-19.487,6.076-31.214-11.733h0q-2.436-3.611-4.436-2.992a47.456,47.456,0,0,1-9.867,3.606c-7.435,2.022-8.105,6.344.548,10.606a21.464,21.464,0,0,0,2.591,1.095c11.6,4.046,15.615,14.211,8.744,21.455-13.092,13.8-17.959,21.52-13.929,28.35q14.244,28.09,34.932,17.389-16.744,25.986-38.956-5.478-13.245-14.874-6.963-26.735,5.386-5.441,14.738-15.511",
    transform: "translate(-993.122 -1195.182)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7602",
    "data-name": "Group 7602",
    transform: "translate(102.386 187.844)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7601",
    "data-name": "Group 7601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7600",
    "data-name": "Group 7600",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24027",
    "data-name": "Path 24027",
    d: "M835.53,1521.639q8.235,4.631,13.861,2.108,2.165,9.35,8.195,13.412a95.286,95.286,0,0,1-15.845,9.287q-6.164-9.356-12.362-11.215,14.643-.362,6.151-13.593",
    transform: "translate(-829.379 -1521.639)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7605",
    "data-name": "Group 7605",
    transform: "translate(70.792 122.11)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7604",
    "data-name": "Group 7604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7603",
    "data-name": "Group 7603",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24028",
    "data-name": "Path 24028",
    d: "M617.864,997.132A52.425,52.425,0,0,0,593.41,1010.8a51.328,51.328,0,0,0-10.266,14.738q3.136-28.8-9.69-18.936a28.391,28.391,0,0,1,31.37-16.982,41.09,41.09,0,0,1,13.039,7.514",
    transform: "translate(-573.454 -989.161)",
    fill: "#381a46",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24029",
    "data-name": "Path 24029",
    d: "M1197.284,1804.145a33.222,33.222,0,0,0,10.144-1.582l-1.01-3.157a30.547,30.547,0,0,1-35.558-13.729l-2.87,1.659a33.92,33.92,0,0,0,29.3,16.81",
    transform: "translate(-1023.802 -1565.237)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24030",
    "data-name": "Path 24030",
    d: "M1325.128,1972.5c-1.045.69-2.021,1.445-2.993,2.2l-1.444,1.147c-.471.394-.946.784-1.427,1.165-.937.8-1.911,1.541-2.829,2.379a15.663,15.663,0,0,0-2.556,2.95l-.153.235a.65.65,0,0,0,.814.946,70.963,70.963,0,0,0,13.246-8.062,1.969,1.969,0,0,0-2.266-3.219Z",
    transform: "translate(-1151.455 -1728.488)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7608",
    "data-name": "Group 7608",
    transform: "translate(104.733 149.381)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7607",
    "data-name": "Group 7607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7606",
    "data-name": "Group 7606",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24031",
    "data-name": "Path 24031",
    d: "M895.713,1233.373a42.731,42.731,0,0,1,6.983-22.846,20.351,20.351,0,0,0-10.675,13.841v.005q-.263,1.169-.421,2.412-.938,3.737-3.387,4.5l-.438.112h-.007a84.912,84.912,0,0,1-14.247,2.525q-6.064-.8-7.183-4.8l-.2-1v-.005a76.286,76.286,0,0,1-1.756-18.041c-9.827,12.493-14.94,21.078-15.993,26.584q16.968,7.911,47.321-3.282",
    transform: "translate(-848.392 -1210.071)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24032",
    "data-name": "Path 24032",
    d: "M1274.969,1102.362l-47.843,17.543a11,11,0,0,1-14.079-6.525l-9.334-25.46a11.011,11.011,0,0,1,4.543-13.115,10.658,10.658,0,0,1,1.982-.964l47.836-17.54a11,11,0,0,1,14.079,6.525l7.4,20.164,1.944,5.294a11.005,11.005,0,0,1-6.525,14.079",
    transform: "translate(-1054.53 -925.314)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24033",
    "data-name": "Path 24033",
    d: "M1203.15,1106.729a12.592,12.592,0,0,1-6.581-7.13l-9.529-25.986a12.7,12.7,0,0,1,7.541-16.274l48.362-17.734a12.714,12.714,0,0,1,16.274,7.541l9.529,25.986a12.7,12.7,0,0,1-7.541,16.274l-48.363,17.734a12.586,12.586,0,0,1-9.693-.412m41.163-63.389-48.362,17.734a8.716,8.716,0,0,0-5.176,11.17l9.529,25.986a8.736,8.736,0,0,0,11.169,5.176l48.363-17.734a8.715,8.715,0,0,0,5.176-11.17l-9.529-25.986a8.707,8.707,0,0,0-11.17-5.176",
    transform: "translate(-1039.821 -910.586)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7611",
    "data-name": "Group 7611",
    transform: "translate(148.587 149.467)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7610",
    "data-name": "Group 7610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7609",
    "data-name": "Group 7609",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24034",
    "data-name": "Path 24034",
    d: "M1208.84,1210.764c3.378.808,5.527,1.33,5.527,1.33,9.823,19.582,19.379,27.639,44.908,18.748,11.019-3.841,17.321-8.047,20.859-11.894l1.944,5.294a11.005,11.005,0,0,1-6.525,14.079l-47.843,17.543-.014,0-.06.022c-.328.12-.659.217-.99.3l-.012,0a11,11,0,0,1-10.589-2.928,10.713,10.713,0,0,1-2.48-3.907l-4.152-11.309-1.37-3.733-2.4-6.555.065-.033-1.413-3.853a11.011,11.011,0,0,1,4.543-13.115",
    transform: "translate(-1203.629 -1210.764)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24035",
    "data-name": "Path 24035",
    d: "M1203.762,1210.477a12.865,12.865,0,0,1-6.725-7.289l-9.335-25.46a12.994,12.994,0,0,1,7.706-16.634l10.334-3.787,1.7,3.575a8.991,8.991,0,0,0-3.835,10.8l9.338,25.464a9.01,9.01,0,0,0,11.532,5.338l29.81-10.731c.207-.075.415-.15.622-.219l.715-.262.016.045c1.084-.266,2.05-.18,2.53,1.152l.66,1.865-1.857.681h0l-43.307,15.88a12.856,12.856,0,0,1-9.9-.42m12.175-4.672a12.862,12.862,0,0,1-6.724-7.288l-9.337-25.463a12.934,12.934,0,0,1,.209-9.438l-3.307,1.212a9.017,9.017,0,0,0-5.342,11.529l9.336,25.463h0a9.011,9.011,0,0,0,11.522,5.342l3.669-1.345Z",
    transform: "translate(-1040.383 -1014.438)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24036",
    "data-name": "Path 24036",
    d: "M1398.343,1270.712c.34.943,1.757,9.038,1.757,9.038l-5.375,1.936c-3.7,1.333-8.082-1.418-9.785-6.146s-.083-9.641,3.619-10.974l5.375-1.936s3.856,6.545,4.41,8.082",
    transform: "translate(-1213.376 -1106.76)",
    fill: "#c29515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24037",
    "data-name": "Path 24037",
    d: "M1374.265,1269.847a11.771,11.771,0,0,1-.229-7.624,7.7,7.7,0,0,1,4.646-5.046l3.753-1.352a3.393,3.393,0,0,1,4.092,1.5,64.819,64.819,0,0,1,3.637,6.8c.078.216.315.874,1.509,7.535a3.385,3.385,0,0,1-2.193,3.792l-3.733,1.345a6.95,6.95,0,0,1-2.365.41c-3.733,0-7.513-2.9-9.117-7.354m9.965-11.2a.743.743,0,0,0-.9-.327l-3.753,1.352a5.111,5.111,0,0,0-3.025,3.381,9.112,9.112,0,0,0,.205,5.9c1.452,4.031,5.08,6.429,8.088,5.347l3.733-1.344a.741.741,0,0,0,.481-.829c-.845-4.708-1.279-6.77-1.394-7.1a70.962,70.962,0,0,0-3.439-6.371m4.68,5.922h0Z",
    transform: "translate(-1203.949 -1100.618)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24038",
    "data-name": "Path 24038",
    d: "M1441.886,1266.389c1.7,4.727.083,9.641-3.619,10.974s-8.082-1.418-9.785-6.146-.083-9.641,3.619-10.974,8.082,1.418,9.785,6.146",
    transform: "translate(-1251.544 -1104.374)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7614",
    "data-name": "Group 7614",
    transform: "translate(176.263 155.534)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7613",
    "data-name": "Group 7613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7612",
    "data-name": "Group 7612",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24039",
    "data-name": "Path 24039",
    d: "M1428.494,1271.222c.128.356.27.7.426,1.026-.64-4.007,1-7.748,4.155-8.886,3.427-1.235,7.428,1.031,9.359,5.119a11.149,11.149,0,0,0-.538-2.089c-1.7-4.728-6.081-7.477-9.784-6.145s-5.32,6.247-3.617,10.976",
    transform: "translate(-1427.817 -1259.91)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24040",
    "data-name": "Path 24040",
    d: "M1428.573,1302.465c1.7,4.723,6.081,7.477,9.784,6.145s5.32-6.247,3.617-10.976a11.283,11.283,0,0,0-.992-2.081c.172,3.54-1.446,6.668-4.285,7.691-3.113,1.125-6.715-.646-8.791-4.059a11.485,11.485,0,0,0,.667,3.279",
    transform: "translate(-1251.632 -1135.619)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24041",
    "data-name": "Path 24041",
    d: "M1417.863,1262.275c-1.947-5.408.034-11.092,4.418-12.671s9.534,1.537,11.482,6.944h0c1.948,5.408-.034,11.092-4.417,12.671a6.956,6.956,0,0,1-2.365.41c-3.732,0-7.512-2.9-9.117-7.354m13.4-4.828c-1.453-4.032-5.078-6.432-8.088-5.348s-4.272,5.245-2.82,9.277,5.083,6.43,8.088,5.347,4.273-5.245,2.82-9.277Z",
    transform: "translate(-1242.173 -1094.982)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24042",
    "data-name": "Path 24042",
    d: "M1595.282,1118.556a1.663,1.663,0,0,0,.529-.087,1.642,1.642,0,0,0,1.025-2.083l-4.418-12.991a7.817,7.817,0,0,1,1.219-7.317,11.066,11.066,0,0,0,1.655-10.594l-6.6-18.181a1.641,1.641,0,1,0-3.085,1.119l6.6,18.182a7.8,7.8,0,0,1-1.167,7.467,11.091,11.091,0,0,0-1.729,10.382l4.417,12.99a1.642,1.642,0,0,0,1.554,1.113",
    transform: "translate(-1389.784 -934.598)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24043",
    "data-name": "Path 24043",
    d: "M843.039,1399.131a33.835,33.835,0,0,1,.745-8.245,77.149,77.149,0,0,0,49.878-5.143,4.878,4.878,0,1,1,3.557,8.958q-29.138,14.208-52.353,6.825l-1.826-2.4",
    transform: "translate(-738.967 -1214.081)",
    fill: "#fc0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24044",
    "data-name": "Path 24044",
    d: "M830.138,1389.309a1.991,1.991,0,0,1-.979-.69l-1.827-2.4a1.991,1.991,0,0,1-.407-1.2,35.3,35.3,0,0,1,.814-8.765,1.992,1.992,0,0,1,2.356-1.421,75.531,75.531,0,0,0,48.535-4.974,6.867,6.867,0,1,1,5.146,12.61c-12.95,6.287-25.173,9.44-36.527,9.44a56.152,56.152,0,0,1-17.111-2.6m50.41-15.966a2.029,2.029,0,0,1-.193.1,79.361,79.361,0,0,1-49.135,5.695,42.092,42.092,0,0,0-.315,5.212l1.032,1.353c14.76,4.493,31.673,2.172,50.285-6.9a1.994,1.994,0,0,1,.432-.152,2.888,2.888,0,1,0-2.107-5.3m-51.64,11.674h0Z",
    transform: "translate(-724.842 -1199.968)",
    fill: "#381a46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7617",
    "data-name": "Group 7617",
    transform: "translate(105.423 174.06)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7616",
    "data-name": "Group 7616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7615",
    "data-name": "Group 7615",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24045",
    "data-name": "Path 24045",
    d: "M900.492,1419.932q-39.532,10.139-46.515-.908,28.45,6.8,57.614-9.046-1.177,6.521-11.1,9.954",
    transform: "translate(-853.977 -1409.978)",
    fill: "#371a45",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24046",
    "data-name": "Path 24046",
    d: "M714.84,101.045C686.531,184.6,569.125,149.431,587.569,66.5,614.518-19.71,735.844,16.752,714.84,101.045",
    transform: "translate(-513.32 -15.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24047",
    "data-name": "Path 24047",
    d: "M714.84,101.045C686.531,184.6,569.125,149.431,587.569,66.5,614.518-19.71,735.844,16.752,714.84,101.045",
    transform: "translate(-513.32 -15.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24048",
    "data-name": "Path 24048",
    d: "M714.84,101.045C686.531,184.6,569.125,149.431,587.569,66.5,614.518-19.71,735.844,16.752,714.84,101.045",
    transform: "translate(-513.32 -15.026)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24049",
    "data-name": "Path 24049",
    d: "M622.952,136.994a68.341,68.341,0,0,1-39.059-28.14c-9.907-15.183-12.821-33.656-8.425-53.42l.032-.121c6.35-20.315,18.39-35.407,34.817-43.645,14.568-7.305,31.727-8.766,48.321-4.109a68.461,68.461,0,0,1,39.5,28.713c9.916,15.523,12.515,34.332,7.516,54.392l-.034.118c-6.679,19.712-18.791,34.339-35.027,42.3a64.977,64.977,0,0,1-28.656,6.544,70.485,70.485,0,0,1-18.984-2.634m34.876-126.55c-28.841-8.092-65.993,2.763-79.449,45.7-9.359,42.224,16.956,70.011,45.381,77.962,29.089,8.138,64.794-2.386,79-44.228,10.662-42.92-15.811-71.264-44.934-79.437",
    transform: "translate(-502.681 -4.282)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7620",
    "data-name": "Group 7620",
    transform: "translate(72.233 43.376)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7619",
    "data-name": "Group 7619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7618",
    "data-name": "Group 7618",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24050",
    "data-name": "Path 24050",
    d: "M714.413,394.015c-23.194,72.59-124.219,58.247-129.285-14.82,9.175,22.053,17.307,21.279,31.916,30.387,45.366,30.436,97.692-10.227,95.158-58.208a65.955,65.955,0,0,1,2.211,42.641",
    transform: "translate(-585.128 -351.373)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24051",
    "data-name": "Path 24051",
    d: "M618.5,133.3a68.947,68.947,0,0,1-39.4-28.391c-10-15.323-12.94-33.954-8.509-53.881l.046-.17c6.4-20.475,18.545-35.691,35.122-44C620.461-.523,637.776-2,654.511,2.7a69.065,69.065,0,0,1,39.846,28.969c10.007,15.667,12.633,34.638,7.594,54.863l-.049.166c-6.732,19.867-18.949,34.615-35.332,42.648a65.579,65.579,0,0,1-28.922,6.606A71.108,71.108,0,0,1,618.5,133.3M653.375,6.746c-28.561-8.016-65.36,2.74-78.7,45.277-9.26,41.828,16.8,69.35,44.959,77.225,28.812,8.06,64.174-2.368,78.261-43.817,10.549-42.517-15.672-70.591-44.518-78.686",
    transform: "translate(-498.393 -0.004)",
    fill: "#293856"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24052",
    "data-name": "Path 24052",
    d: "M619.329,133.985a68.833,68.833,0,0,1-39.338-28.344c-9.981-15.3-12.918-33.9-8.493-53.794l.043-.162c6.391-20.445,18.516-35.638,35.065-43.936C621.284.387,638.569-1.084,655.279,3.6a68.953,68.953,0,0,1,39.781,28.922c9.991,15.64,12.611,34.581,7.579,54.775l-.047.157c-6.722,19.838-18.919,34.563-35.275,42.584a65.461,65.461,0,0,1-28.872,6.594,70.982,70.982,0,0,1-19.117-2.652M654.2,7.434c-28.616-8.028-65.48,2.742-78.842,45.357-9.276,41.9,16.834,69.473,45.038,77.362,28.868,8.072,64.29-2.37,78.4-43.894,10.573-42.593-15.7-70.716-44.6-78.825",
    transform: "translate(-499.191 -0.8)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24053",
    "data-name": "Path 24053",
    d: "M853.922,195.224c-53.959,55.562-129.115-4.579-92.222-61.476,45.194-61.219,129.26-8.062,92.222,61.476",
    transform: "translate(-659.066 -93.676)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24054",
    "data-name": "Path 24054",
    d: "M884.56,426.1c18.748,67.445-76.278,99.48-103.538,40.632C821.9,494.613,875.4,463.721,884.56,426.1",
    transform: "translate(-684.606 -373.497)",
    fill: "#21102b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24055",
    "data-name": "Path 24055",
    d: "M733.84,164.818a63.032,63.032,0,0,1-36.7-22.022c-10.1-12.482-14.611-28.056-13.048-45.081,2.065-17.534,12.052-34.064,27.4-45.351,15.4-11.326,34.267-15.939,51.762-12.659l.271.075c34.06,12.635,47.642,51.886,38.959,80.617l0,.011c-5.378,17.32-15.244,30.526-28.531,38.191a56.327,56.327,0,0,1-28.194,7.4,61.088,61.088,0,0,1-11.91-1.181M762.5,42.939c-16.558-3.062-34.427,1.344-49.048,12.1s-24.113,26.442-26.067,43.025c-3.2,34.906,21.271,58.369,47.1,63.506,22.474,4.471,52.94-3.884,64.82-42.134,8.234-27.253-4.594-64.456-36.808-76.494",
    transform: "translate(-599.372 -33.899)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24056",
    "data-name": "Path 24056",
    d: "M758.946,194.672a53.959,53.959,0,0,1-19.653-32.211c-2.561-13.825.63-28.14,9.225-41.4l.057-.083c10.682-14.47,24.277-23.657,39.316-26.57a54.035,54.035,0,0,1,39.223,7.454,55.049,55.049,0,0,1,24.1,33.228c3.9,15.455,1.269,32.443-7.618,49.128l-.11.207-.163.169c-13.2,13.6-28.69,21.356-44.785,22.441q-1.949.131-3.887.131a57.178,57.178,0,0,1-35.7-12.5m66.4-90c-20.574-12.976-51.453-12.366-74.073,18.24-18.114,27.978-8.164,54.9,9.74,69.169,19.719,15.718,52.006,18.82,79.766-9.623,18.555-35.053,5.027-64.882-15.434-77.786",
    transform: "translate(-647.275 -81.895)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24057",
    "data-name": "Path 24057",
    d: "M548.76,617.091c12.194,28.615,41.9,18.8,33.012-9.69-11.68-30.46-43.435-19.974-33.012,9.69",
    transform: "translate(-479.202 -516.357)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7623",
    "data-name": "Group 7623",
    transform: "translate(68.668 80.244)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7622",
    "data-name": "Group 7622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7621",
    "data-name": "Group 7621",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24058",
    "data-name": "Path 24058",
    d: "M581.892,687.076c8.926-2.876,12.6-15.659,7.712-27.727-2.25,14.586-21.689-3.4-24.283-9.331-21.712,11.984.29,42.693,16.571,37.058",
    transform: "translate(-556.248 -650.018)",
    fill: "#371a45"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24059",
    "data-name": "Path 24059",
    d: "M535.491,606.1l-.039-.1c-5.587-15.9.527-26.326,8.573-29.281,8.917-3.273,21.247,2.008,27.551,18.448l.034.1c4.792,15.362-1.051,25.178-8.967,28.092a15.308,15.308,0,0,1-5.291.924c-7.524,0-16.335-5.215-21.861-18.182m9.677-26.269c-6.56,2.409-11.419,11.265-6.606,25.019,6.051,14.151,16.126,17.9,22.936,15.4,6.436-2.368,11.08-10.689,6.964-23.942-5.54-14.4-15.9-19.186-23.294-16.474m-8.158,25.619h0Z",
    transform: "translate(-467.459 -504.715)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24060",
    "data-name": "Path 24060",
    d: "M544.467,673.735c9.906,23.179,32.284,16.2,25.1-6.843-9.455-25.005-33.766-17.4-25.1,6.843",
    transform: "translate(-475.644 -571.034)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24061",
    "data-name": "Path 24061",
    d: "M531.268,662.683l-.036-.093c-4.677-13.083-.1-21.509,6.134-23.8,7.021-2.582,16.86,2.021,22.076,15.814l.032.094c3.9,12.511-.471,20.367-6.535,22.6a11.252,11.252,0,0,1-3.9.679c-5.961,0-13.116-4.4-17.773-15.293M538.51,641.9c-4.741,1.744-8.064,8.6-4.174,19.527,4.884,11.387,12.465,14.6,17.457,12.76,4.585-1.69,7.759-8.051,4.53-18.457C551.868,643.986,544,639.883,538.51,641.9m-5.723,20.132h0Z",
    transform: "translate(-463.969 -559.331)",
    fill: "#371a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7626",
    "data-name": "Group 7626",
    transform: "translate(104.327 66.431)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7625",
    "data-name": "Group 7625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7624",
    "data-name": "Group 7624",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24062",
    "data-name": "Path 24062",
    d: "M846.311,550.792c6.206,10.58,18.34,3.713,14.517-6.337-5.537-12.4-19.969-4.54-14.517,6.337",
    transform: "translate(-845.101 -538.134)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7629",
    "data-name": "Group 7629",
    transform: "translate(116.534 89.878)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7628",
    "data-name": "Group 7628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7627",
    "data-name": "Group 7627",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24063",
    "data-name": "Path 24063",
    d: "M944.6,733.4c2.607,3.909,7.972,1.008,5.533-3.5-2.607-3.909-7.972-1.008-5.533,3.5",
    transform: "translate(-943.982 -728.062)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7632",
    "data-name": "Group 7632",
    transform: "translate(129.146 21.341)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7631",
    "data-name": "Group 7631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7630",
    "data-name": "Group 7630",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24064",
    "data-name": "Path 24064",
    d: "M1109.279,209.813c-3.745-46.56-51.5-40.646-63.133-27.619,30.183-5.468,47.953,9.527,63.133,27.619",
    transform: "translate(-1046.146 -172.878)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7635",
    "data-name": "Group 7635",
    transform: "translate(67.481 91.155)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7634",
    "data-name": "Group 7634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7633",
    "data-name": "Group 7633",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24065",
    "data-name": "Path 24065",
    d: "M575.679,748.275a22.348,22.348,0,0,0-3.844-9.868c-.166,17.423-18.422,14.384-25.2,3.634,2.5,25.073,29.913,30.133,29.047,6.235",
    transform: "translate(-546.632 -738.407)",
    fill: "#371a45"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.06e7f5171b6368537b23a4df327c899f.svg";
export { ForwardRef as ReactComponent };